import { render, staticRenderFns } from "./BaseLegend.vue?vue&type=template&id=09208ea4&"
import script from "./BaseLegend.vue?vue&type=script&lang=js&"
export * from "./BaseLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports